// URLクリーンアップとトークン保存のユーティリティ関数
export function cleanupUrlAndStoreToken() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  if (token) {
    try {
      const decoded = decodeURIComponent(atob(token));
      const obj = JSON.parse(decoded);
      // 3項目まとめて1つのオブジェクトとして暗号化し、キー名も推測されにくいものにする
      const bundle = {
        a: obj.loginToken,
        b: obj.id,
        c: obj.fromApp,
        d: obj.distributionPlaceId,
        e: obj.sessionId,
        f: obj.frimoActuateId,
      };
      // まとめて暗号化して保存（キー名も難読化）
      const encrypted = btoa(encodeURIComponent(JSON.stringify(bundle)));
      sessionStorage.setItem('___tkn', encrypted);
    } catch (e) {
      // デコード失敗時は何もしない
      console.error('token decode error', e);
    }
    // tokenをURLから消す
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }
  // tokenが無い場合はストレージを変更しない
}

// まとめて暗号化されたトークンから各値を取得するユーティリティ
export function getDecryptedSessionItem(
  key: 'loginToken' | 'reporterId' | 'fromApp' | 'distributionId' | 'sessionId' | 'frimoActuateId'
): string | null {
  const encrypted = sessionStorage.getItem('___tkn');
  if (!encrypted) return null;
  try {
    const decoded = decodeURIComponent(atob(encrypted));
    const bundle = JSON.parse(decoded);
    if (key === 'loginToken') return bundle.a ?? null;
    if (key === 'reporterId') return bundle.b ?? null;
    if (key === 'fromApp') return bundle.c ?? null;
    if (key === 'distributionId') return bundle.d ?? null;
    if (key === 'sessionId') return bundle.e ?? null;
    if (key === 'frimoActuateId') return bundle.f ?? null;
    return null;
  } catch (e) {
    return null;
  }
}

// まとめて暗号化されたトークンから各値を取得する共通関数
export function getTokenBundle() {
  const encrypted = sessionStorage.getItem('___tkn');
  if (!encrypted) return null;
  try {
    const decoded = decodeURIComponent(atob(encrypted));
    const bundle = JSON.parse(decoded);
    return bundle;
  } catch (e) {
    return null;
  }
}

/**
 * 開発用: 任意のreporterIdをセットする
 * @param loginToken ログイントークン
 * @param reporterId セットしたいID
 * @param fromApp 任意のfromApp（省略可、デフォルト: 'garage'）
 * @param distributionId 任意のdistributionId（省略可）
 * @param sessionId セッションID（省略可）
 * @param frimoActuateId 任意のfrimoActuateId（省略可）
 */
export function setDevReporterId(
  loginToken: string,
  reporterId: string,
  fromApp: string = 'garage',
  distributionId?: string,
  sessionId?: string,
  frimoActuateId?: string
) {
  const bundle = {
    a: loginToken,
    b: reporterId,
    c: fromApp,
    d: distributionId,
    e: sessionId,
    f: frimoActuateId,
  };
  const encrypted = btoa(encodeURIComponent(JSON.stringify(bundle)));
  sessionStorage.setItem('___tkn', encrypted);
}

/**
 * 現在のreporterIdを取得する
 * @returns reporterId もしくは null
 */
export function getCurrentReporterId(): string | null {
  return getDecryptedSessionItem('reporterId');
}

/**
 * 現在のdistributionIdを取得する
 * @returns distributionId もしくは null
 */
export function getCurrentDistributionId(): string | null {
  return getDecryptedSessionItem('distributionId');
}

/**
 * 現在のfrimoActuateIdを取得する
 * @returns frimoActuateId もしくは null
 */
export function getCurrentFrimoActuateId(): string | null {
  return getDecryptedSessionItem('frimoActuateId');
}

/**
 * セッションストレージからトークン情報をクリアする
 */
export function clearToken(): void {
  sessionStorage.removeItem('___tkn');
}
